import { useState } from "react";
import Card from "../../../../components/layouts/card/card";
import GridLineLayout from "../../../../components/layouts/grid-line-layout/grid-line-layout";
import { ConfirmModal } from "../../../../components/modal/components/confirm-modal/confirm-modal";
import PolicyStore from "../../stores/policy-store";
import PolicyLine from "./policy-line/policy-line";

interface IProps {
    policyList: PolicyStore[],
    title: React.ReactChild,
    isExpanded: boolean,
    onExpandClick: (expanded: boolean) => void,
}

const PolicyCategoryCard: React.FC<IProps> = ({ policyList, title, isExpanded, onExpandClick }) => {
    const [policyToDelete, setPolicyToDelete] = useState(undefined as PolicyStore | undefined);
    return (
        <Card
            toolbar={{
                title: title
            }}
            isExpanded={isExpanded}
            expandCallback={onExpandClick}
        >
            <GridLineLayout>
                {policyList.map((policy, index) => (
                    <PolicyLine key={index} policy={policy} deleteCallback={() => setPolicyToDelete(policy)} />
                ))}
            </GridLineLayout>
            {policyToDelete &&
                <ConfirmModal
                    title="Delete policy rule"
                    text={
                        <>
                            You asked to <strong>delete</strong> the
                            policy rule: <strong>{policyToDelete.name}</strong>
                        </>
                    }
                    questionText="Are you sure you want to delete this rule?"
                    cancelButton={{
                        title: 'Cancel',
                        onClick: () => {
                            setPolicyToDelete(undefined);
                        }
                    }}
                    okButton={{
                        title: 'Delete',
                        onClick: async () => {
                            setPolicyToDelete(undefined);
                            await policyToDelete.delete();
                        }
                    }}
                />
            }
        </Card>
    )
};

export default PolicyCategoryCard;
